/*	==================================================================================================================================
	==================================================================================================================================
	===================================== Copyright: Nasriya Software, LLC. (www.nasriya.net) ========================================
	==================================================================================================================================
	==================================================================================================================================
*/
import { checkRequest } from 'backend/requests.jsw';
import wixWindow from 'wix-window';

$w.onReady(function () {
    initializePage();
});

function initializePage() {
    step1();

    function step1() {
        $w('#submittingLoading').scrolling = 'no';

        $w('#fullName, #warrantyReference').onInput(() => {
            let name = $w('#fullName').value;
            let reference = $w('#warrantyReference').value;

            if (reference.length > 0 && name.length > 0 && $w('#brand').value.length > 0) {
                $w('#checkRequest').enable();
            } else {
                $w('#checkRequest').disable();
            }
        })

        $w('#brand').onChange(() => {
            if ($w('#warrantyReference').value.length > 0 && $w('#fullName').value.length > 0 && $w('#brand').value.length > 0) {
                $w('#checkRequest').enable();
            } else {
                $w('#checkRequest').disable();
            }
        })

        $w('#checkRequest').onClick(() => {
            $w('#requestStages').changeState('checkingRequest').then(async () => {
                $w('#checkRequest').enable();

                let requset = {
                    name: $w('#fullName').value,
                    reference: $w('#warrantyReference').value,
                    brand: $w('#brand').value
                }

                await checkRequest(requset).then((result) => {
                    if (result.ok) {
                        const json = result.json;                        
                        let keys = Object.keys(json);
                        keys.forEach(key => {
                            let value = json[key]
                            value = value.replaceAll('&#xA;', '');
                            value = value.replaceAll('&#xD;', ' - ')
                            json[key] = value;
                        })

                        if (wixWindow.viewMode === 'Preview') { console.info(json); }
                        $w('#customerName').text = $w('#fullName').value;
                        $w('#referenceId').text = String(json.csoid);
                        $w('#model').text = json.modelname || 'N/A';
                        $w('#serial').text = json.SERIAL || 'N/A';
                        $w('#imei').text = json.IMEI || 'N/A';                       
                        $w('#customerNotice').text = json.Customernotice || 'N/A';
                        if (json.callstatus === 'בתהליך') { // Status
                            $w('#status').text = "בקשתך עדיין ממתינה לבדיקה, אנא המתן!";
                        } else {
                            $w('#status').text = json.callstatus || 'N/A';
                        }

                        if (json.Shipingcompany) {
                            $w('#shippingCompany').text = json.Shipingcompany;
                            $w('#shippingPhone').text = json.phoneshippingcompany || 'N/A';
                            $w('#shippingNote').text = json.Shippingnote || 'N/A';
                        } else {
                            $w('#shippingCompany').text = 'N/A';
                            $w('#shippingPhone').text = 'N/A';
                            $w('#shippingNote').text = 'N/A';
                        }

                        $w('#requestStages').changeState('success');
                    } else {
                        if (result.json.reason === 'not found') {
                            $w('#checkingRequestErrorMsg').text = 'הפניה לאחריות שהוזנה אינה קיימת.';
                            $w('#checkingRequestErrorMsg').expand();
                            $w('#requestStages').changeState('step1');
                        } else {
                            $w('#universalError').text = `אירעה שגיאה - הודעת שגיאה: ${result.json.message}.`;
                            $w('#universalError').expand();
                            $w('#requestStages').changeState('error');
                        }
                    }

                }).catch(async (err) => {
                    console.error(err.adminMessage);
                    if (err.type === 'not found') {
                        $w('#checkingRequestErrorMsg').text = err.message || "Unable to send request at the moment";
                        $w('#checkingRequestErrorMsg').expand();
                        $w('#requestStages').changeState('step1');
                    } else {
                        $w('#universalError').text = err.message || "Unable to send request at the moment";
                        $w('#requestStages').changeState('error');
                    }
                })
            })
        })

        $w('#startAgain').onClick(() => {
            $w('#header').scrollTo();
            $w('#fullName, #warrantyReference').value = '';
            $w('#brand').value = null;
            $w('#checkRequest').disable();
            $w('#requestStages').changeState('step1');
        })
    }  
}
/*	==================================================================================================================================
	==================================================================================================================================
	===================================== Copyright: Nasriya Software, LLC. (www.nasriya.net) ========================================
	==================================================================================================================================
	==================================================================================================================================
*/